// extracted by mini-css-extract-plugin
export default {"form":"ProfileForm_form__M3YQj","control":"ProfileForm_control__O2yDH","action":"ProfileForm_action__VcUiR","cancel-btn":"ProfileForm_cancel-btn__dElbj"};